<template>
  <div id="TranshipmentBarChart">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col class="d-flex align-center">
            <h6>Financeiro</h6>
          </v-col>
        </v-row>
      </v-card-title>
      <div v-if="isLoading" class="d-flex justify-center py-12">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <v-card-text v-else class="chart">
        <ul class="list">
          <li v-for="(item, i) in transhipmentFinancialQuantityArray" :key="i" class="d-flex">
            <div class="status-label d-flex align-center" style="width: 75%">
              <div>
                <v-avatar size="28" class="mx-2">
                  <v-icon :class="`${item.color} lighten-1`" size="16" dark> {{ item.icon }} </v-icon>
                </v-avatar>
              </div>
              {{ item.label }}
            </div>
            <div class="status-quantity d-flex align-center justify-end pr-2" style="width: 25%">
              {{ formatMoney(item.financialData) }}
            </div>
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { orderBy } from 'lodash';
import { mapActions } from 'vuex';
export default {
  name: 'TranshipmentFinancialBarChart',
  props: {
    transhipmentId: {
      default: null,
      type: String
    },

    date: {
      default: null,
      type: Object
    }
  },
  data: () => ({
    isLoading: true,
    chartOptions: {},
    chartLabels: [],
    chartData: [],
    charts: null,
    transhipmentFinancialQuantity: null
  }),

  computed: {
    transhipmentData() {
      const barColors = [
        { color: 'rgba(54, 162, 235, 0.2)', borderColor: 'rgba(54, 162, 235, 1)' },
        { color: 'rgba(75, 192, 192, 0.2)', borderColor: 'rgba(75, 192, 192, 1)' },
        { color: 'rgba(255, 159, 64, 0.2)', borderColor: 'rgba(255, 159, 64, 1)' },

        { color: 'rgba(26, 255, 26, 0.2) ', borderColor: 'rgba(0, 179, 0, 1)' },
        { color: 'rgba(255, 206, 86, 0.2)', borderColor: 'rgba(255, 206, 86, 1)' }
      ];
      const labels = ['Adicional', 'Desconto', 'Planejado', 'Pago', 'Contas a pagar'];
      let datasets = [];

      if (this.transhipmentFinancialQuantity !== null) {
        Object.keys(this.transhipmentFinancialQuantity).map((key, i) => {
          let newDataset = {
            label: labels[i],
            data: [this.transhipmentFinancialQuantity[key]],
            backgroundColor: [barColors[i].color],
            borderColor: [barColors[i].borderColor],
            borderWidth: 1
          };
          datasets = [...datasets, newDataset];
        });
        return datasets;
      }

      return [];
    },
    transhipmentFinancialQuantityArray() {
      if (this.transhipmentFinancialQuantity) {
        const statuses = {
          billsToPay: { label: 'Contas a pagar', color: 'orange', icon: 'mdi-hand-coin-outline', index: 0 },
          planned: { label: 'Planejado', color: 'blue', icon: 'mdi-calendar', index: 1 },
          paid: { label: 'Pago', color: 'green', icon: 'mdi-cash', index: 2 },
          addition: { label: 'Créditos', color: 'cyan', icon: 'mdi-cash-plus', index: 3 },
          discount: { label: 'Débitos', color: 'red', icon: 'mdi-cash-minus', index: 4 }
        };

        let array = Object.entries(this.transhipmentFinancialQuantity).reduce((acc, [key, value]) => {
          const { label, color, icon, index } = statuses[key];
          return [...acc, { label, color, icon, index, financialData: value }];
        }, []);
        return orderBy(array, ['index'], ['asc']);
      }
      return null;
    }
  },

  watch: {
    date: {
      async handler() {
        await this.fetchTranshipmentQuantityData({
          startDate: this.date.startDate,
          endDate: this.date.endDate,
          transhipmentId: this.transhipmentId
        });
      }
    }
  },

  async mounted() {
    await this.fetchTranshipmentQuantityData();
  },

  methods: {
    ...mapActions('TranshipmentStore', [
      'getTranshipmentFinancialQuantityByTranshipmentId',
      'getTranshipmentsFinancialQuantity'
    ]),
    async fetchTranshipmentQuantityData(params = { startDate: '', endDate: '', transhipmentId: this.transhipmentId }) {
      try {
        this.isLoading = true;

        if (params.transhipmentId !== null) {
          const data = await this.getTranshipmentFinancialQuantityByTranshipmentId(params);
          this.transhipmentFinancialQuantity = data;
        } else {
          const data = await this.getTranshipmentsFinancialQuantity(params);
          this.transhipmentFinancialQuantity = data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    formatMoney(element) {
      var money = element.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      return money;
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-screen {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: white;

  border-radius: 5px;
}

.financial-money-text {
  font-weight: 600;
  font-size: 1rem;
  color: rgb(94, 94, 94);
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  height: 250px;
  overflow-y: auto;

  & li {
    background-color: #e2e2e236;
    padding: 14px 12px;
    margin: 5px;
    border-radius: 2px;

    & .status-label,
    .status-quantity {
      color: rgb(60, 60, 60);
      font-weight: 400;
      font-size: 0.95rem;
    }

    & .dot {
      min-height: 10px;
      min-width: 10px;
      background-color: #bbb;
      border-radius: 50%;
    }
  }

  & li:hover {
    background-color: #fff;
  }
}
/* ===== Scrollbar CSS ===== */
/* Firefox */
.list {
  scrollbar-width: thin;
  scrollbar-color: #c7c7c7 #ffffff;
}

/* Chrome, Edge, and Safari */
.list::-webkit-scrollbar {
  width: 6px;
}

.list::-webkit-scrollbar-track {
  background: #ffffff;
}

.list::-webkit-scrollbar-thumb {
  background-color: #c7c7c7;
  border-radius: 10px;
}
</style>
